<template>
  <div v-if="false">
    <!-- <div class="promotion-wrapper">
      <div class="text">
        Get a FREE Hiplok D-lock worth £69.99 with your new policy
      </div>
      <nuxt-link to="/hiplok" class="ps-button short is-outlined button">
        Hiplok offer
      </nuxt-link>
      <div
        class="close-button is-medium is-pulled-right"
        @click="hidePromotion"
      >
        <img
          src="~/assets/images/icons/Close-button-white.svg"
          class="icon alt"
          alt="close icon"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'PromotionBanner',
  computed: {
    isActive() {
      return this.$store.getters['promotion/isActive']
    },
  },
  mounted() {
    this.$store.dispatch('promotion/addPromotion')
  },
  methods: {
    hidePromotion() {
      this.$store.dispatch('promotion/hidePromotion')
    },
  },
}
</script>

<style lang="scss" scoped>
.promotion-banner {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 200;
  width: 100%;
  height: 40px;
  background: $ps-primary;
  @include mobile {
    height: 70px;
    line-height: 20px;
  }
  @include tablet {
    height: 50px;
  }
}
.promotion-wrapper {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #fff;
  font-weight: 400;
  font-size: 18px;
  .text {
    @include mobile {
      width: 50%;
    }
  }
  @include tablet {
    line-height: 50px;
  }
  .button {
    background: white;
    margin: 0 20px;
  }
  .close-button {
    position: absolute;
    padding: 0 20px;
    right: 5px;
    top: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    @include mobile {
      padding: 0 10px;
    }
  }
}
</style>
